import React from "react";
import styles from "./About.module.css";
import Fade from "react-reveal/Fade";
import abtImg from "../../Assets/homeimg.gif";
import Typewriter from "typewriter-effect";

const About = () => {
  return (
    <div className={styles.aboutMainDiv}>
      <div className={styles.aboutDiv}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
          }}
        >
          <h1>
          <Typewriter
                style={{ fontWeight: "bold" }}
                options={{
                  autoStart: true,
                  loop: true,
                  delay: 40,
                  strings: [
                    "About Me()",
                  ],
                }}
              />
          </h1>
          <div className={styles.aboutDivText}>
            <Fade top duration={2000}>
              <p style={{ fontSize: "20px" }}>
                I am an EXTC engineering undergrad student, having a strong
                interest in modern software tech.
              </p>
            </Fade>
            <br />
            <Fade top duration={2000}>
              <p style={{ fontSize: "20px" }}>
              I have over 3 years of experience in App development(majorly using Flutter and also Native Java/Kotlin)
               and 1+ year of experience in Web(MERN) and Backend development(using Nodejs, PHP, Golang).
                I like to explore systems design and greatly interested in studying and working on the current
                modern computer technology.
              </p>
            </Fade>
          </div>
        </div>
        <Fade duration={3000}>
          <img className={styles.aboutDivImg} alt="mypic" src={abtImg} />
        </Fade>
      </div>
    </div>
  );
};

export default About;
